import { useState } from 'react';

import { HelpCircle } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/Tooltip';

import { HelpGuideModal } from './HelpGuideModal';

export function HelpGuideButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => {
              setOpen(true);
            }}
            className="flex h-8 w-8 items-center justify-center rounded-md text-white/70 transition-colors hover:bg-white/10 hover:text-white"
            aria-label="Open User Guide"
          >
            <HelpCircle className="h-5 w-5" aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">User Guide</TooltipContent>
      </Tooltip>
      <HelpGuideModal open={open} onOpenChange={setOpen} />
    </>
  );
}
